import { InputText, TextArea } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const FormBodyWrapperStyled = styled.div`
  width: 100%;
  padding: 0 3.2rem 6rem;
  box-sizing: border-box;
`;

export const InputTextStyled = styled(InputText)`
  margin-bottom: 2rem;
`;

export const TextAreaStyled = styled(TextArea)`
  margin-bottom: 4rem;
`;
